// Gradient AI Icons - Using actual images
// Grey overlay when inactive via CSS filter

import globeSearchIcon from '../../assets/icons/globe-search.png';
import neuralBrainIcon from '../../assets/icons/neural-brain.png';
import aiChipIcon from '../../assets/icons/ai-chip.png';

interface IconProps {
  size?: number;
  className?: string;
  active?: boolean;
}

// Globe + Search Icon (Research Mode)
export function GlobeSearchIcon({ size = 24, className, active = true }: IconProps) {
  return (
    <img 
      src={globeSearchIcon} 
      alt="Research" 
      width={size} 
      height={size}
      className={className}
      style={{ 
        filter: active ? 'none' : 'grayscale(100%) opacity(0.5)',
        transition: 'filter 0.2s ease'
      }}
    />
  );
}

// Neural Brain Icon (Speaker Intelligence)
export function NeuralIcon({ size = 24, className, active = true }: IconProps) {
  return (
    <img 
      src={neuralBrainIcon} 
      alt="Speaker" 
      width={size} 
      height={size}
      className={className}
      style={{ 
        filter: active ? 'none' : 'grayscale(100%) opacity(0.5)',
        transition: 'filter 0.2s ease'
      }}
    />
  );
}

// AI Chip Icon (Model Selector)
export function AIChipIcon({ size = 24, className, active = true }: IconProps) {
  return (
    <img 
      src={aiChipIcon} 
      alt="Model" 
      width={size} 
      height={size}
      className={className}
      style={{ 
        filter: active ? 'none' : 'grayscale(100%) opacity(0.5)',
        transition: 'filter 0.2s ease'
      }}
    />
  );
}
